<div class="search-places-container">
    <div class="search-input-container">
        <form [formGroup]="searchForm">
            <app-icon class="magnifiger" [icon]="Icons.magnifiger"/>
            <input
                    type="text"
                    formControlName="search"
                    inputmode="text"
                    placeholder="Поиск по местам и событиям"
            />
            <app-icon *ngIf="search.length > 0" (click)="clear()" [icon]="Icons.crossWhite" [invert]="0.5"/>
        </form>

    </div>
    <div class="places-container">
        <div class="places-container-item" *ngFor="let icon of categories; index as i">
            <app-button-icon
                    [icon]="icon.icon"
                    [active]="icon.active ?? false"
                    [title]="icon.title"
                    (click)="activate(icon, i)"
            />
        </div>
    </div>
</div>
